import { render, staticRenderFns } from "./DoctorPatientsDialog.vue?vue&type=template&id=4ca71a4e&scoped=true"
import script from "./DoctorPatientsDialog.vue?vue&type=script&lang=js"
export * from "./DoctorPatientsDialog.vue?vue&type=script&lang=js"
import style0 from "./DoctorPatientsDialog.vue?vue&type=style&index=0&id=4ca71a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca71a4e",
  null
  
)

export default component.exports